import '../styles/v3-chrome.css';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Footer() {
    const currentYear = new Date().getFullYear();
    const location = useLocation();
    const onHome = location.pathname === '/';

    const linkTo = (hash) => (onHome ? `#${hash}` : `/#${hash}`);

    return (
        <footer className="v3-footer">
            <div className="v3-footer__inner">
                {/* Column 1: Socials */}
                <div className="v3-footer__col">
                    <h3 className="v3-footer__heading">Connect</h3>
                    <a href="https://www.linkedin.com/in/vijaykagupati/" target="_blank" rel="noopener noreferrer" className="v3-footer__link">
                        LinkedIn
                    </a>
                    <a href="https://github.com/VijayKagupati" target="_blank" rel="noopener noreferrer" className="v3-footer__link">
                        GitHub
                    </a>
                    <a href="https://www.youtube.com/@VijayPages" target="_blank" rel="noopener noreferrer" className="v3-footer__link">
                        YouTube
                    </a>
                    <a href="https://www.instagram.com/vijay_pages/" target="_blank" rel="noopener noreferrer" className="v3-footer__link">
                        Instagram
                    </a>
                </div>

                {/* Column 2: Sitemap */}
                <div className="v3-footer__col">
                    <h3 className="v3-footer__heading">Navigate</h3>
                    {onHome ? (
                        <>
                            <a href="#hero" className="v3-footer__link">Home</a>
                            <a href="#portfolio" className="v3-footer__link">Projects</a>
                            <a href="#work-experience" className="v3-footer__link">Experience</a>
                            <a href="#about" className="v3-footer__link">About</a>
                            <a href="#contact" className="v3-footer__link">Contact</a>
                        </>
                    ) : (
                        <>
                            <Link to="/" className="v3-footer__link">Home</Link>
                            <Link to={linkTo('portfolio')} className="v3-footer__link">Projects</Link>
                            <Link to={linkTo('work-experience')} className="v3-footer__link">Experience</Link>
                            <Link to={linkTo('about')} className="v3-footer__link">About</Link>
                            <Link to={linkTo('contact')} className="v3-footer__link">Contact</Link>
                        </>
                    )}
                </div>

                {/* Column 3: Signature */}
                <div className="v3-footer__col">
                    <p className="v3-footer__signature">[ VIJAY PAGES · {currentYear} ]</p>
                    <a href="mailto:vijaykumarkagupati@gmail.com" className="v3-footer__email">
                        vijaykumarkagupati@gmail.com
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
